import { Category } from "../processors";
import { getColor, getHighlightColors } from "../../themes";

export const figureDeltaString = (delta: number, category: Category, colorIndex?: number) => {
    const fawStyle = `style="color: ${
        colorIndex == null
            ? getColor(category?.theme)
            : getHighlightColors(category?.theme, colorIndex + 1)?.[colorIndex]
    }"`;
    const deltaString = `${
        delta == null
            ? `<span style="opacity: 0;">no data</span>`
            : delta === 0
            ? `<span class='fa-solid fa-right mr-1' ${fawStyle}></span> <span class="light-bold">No change from last year</span>`
            : `${
                  delta > 0
                      ? `<span class='fa-solid fa-up mr-1' ${fawStyle}></span>`
                      : delta < 0
                      ? `<span class='fa-solid fa-down mr-1' ${fawStyle}></span>`
                      : ""
              } ${Math.abs(delta)}% <span class="light-bold">${delta > 0 ? "above" : "below"} last year</span>`
    }`;

    return deltaString;
};
